<script>
import { Transition, h } from 'vue';

export default {
  name: 'TransitionExpand',
  setup(props, { slots }) {
    const onAfterEnter = element => {
      element.style.height = 'auto';
    };

    const onEnter = element => {
      const { width } = getComputedStyle(element);

      element.style.width = width;
      element.style.position = 'absolute';
      element.style.visibility = 'hidden';
      element.style.height = 'auto';

      const { height } = getComputedStyle(element);

      element.style.width = null;
      element.style.position = null;
      element.style.visibility = null;
      element.style.height = '0';

      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = height;
      });
    };

    const onLeave = element => {
      const { height } = getComputedStyle(element);

      element.style.height = height;

      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = '0';
      });
    };

    return () => h(Transition, {
      enterActiveClass: 'overflow-hidden transition-[height] duration-250 ease-in-out',
      leaveActiveClass: 'overflow-hidden transition-[height] duration-250 ease-in-out',
      onAfterEnter,
      onEnter,
      onLeave,
    }, slots.default);
  },
};
</script>
